 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTPTOP_COVER from '@/components/Text/PTOP_cover'
 import TEXTPTOP_TITLEPAGE from '@/components/Text/PTOP_titlepage'
 import TEXTPTOP_IMPRINT from '@/components/Text/PTOP_imprint'
 import TEXTPTOP_CONTENTS from '@/components/Text/PTOP_contents'
 import TEXTPTOP_SERPREF from '@/components/Text/PTOP_serpref'
 import TEXTPTOP_AUTPREF from '@/components/Text/PTOP_autpref'
 import TEXTPTOP_ABBREV from '@/components/Text/PTOP_abbrev'
 import TEXTPTOP_CH01 from '@/components/Text/PTOP_ch01'
 import TEXTPTOP_CH02 from '@/components/Text/PTOP_ch02'
 import TEXTPTOP_CH03 from '@/components/Text/PTOP_ch03'
 import TEXTPTOP_CH04 from '@/components/Text/PTOP_ch04'
 import TEXTPTOP_CH05 from '@/components/Text/PTOP_ch05'
 import TEXTPTOP_CH06 from '@/components/Text/PTOP_ch06'
 import TEXTPTOP_CH07 from '@/components/Text/PTOP_ch07'
 import TEXTPTOP_CH08 from '@/components/Text/PTOP_ch08'
 import TEXTPTOP_CH09 from '@/components/Text/PTOP_ch09'
 import TEXTPTOP_BIBLIOG from '@/components/Text/PTOP_bibliog'
 import TEXTPTOP_NOTES from '@/components/Text/PTOP_notes'
 import TEXTPTOP_IDX_AUT from '@/components/Text/PTOP_idx_aut'
 import TEXTPTOP_IDX_SCR from '@/components/Text/PTOP_idx_scr'
 import TEXTPTOP_SERIES from '@/components/Text/PTOP_series'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTMOREIVP from '@/components/Text/moreIVP'
 import TEXTIVPTBS from '@/components/Text/IVPtbs'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/PTOP_contents",
 			"name" : "Text/PTOP_contents",
 			"component" : TEXTPTOP_CONTENTS
 		},
 		{
 			"path" : "/Text/PTOP_serpref",
 			"name" : "Text/PTOP_serpref",
 			"component" : TEXTPTOP_SERPREF
 		},
 		{
 			"path" : "/Text/PTOP_autpref",
 			"name" : "Text/PTOP_autpref",
 			"component" : TEXTPTOP_AUTPREF
 		},
 		{
 			"path" : "/Text/PTOP_abbrev",
 			"name" : "Text/PTOP_abbrev",
 			"component" : TEXTPTOP_ABBREV
 		},
 		{
 			"path" : "/Text/PTOP_ch01",
 			"name" : "Text/PTOP_ch01",
 			"component" : TEXTPTOP_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js